import {XauditModel} from "../xaudit.model";

export class AppointmentOperatoryDataModel extends XauditModel {
  AppointmentOppId: string;
  AppointmentId: string;
  OperatoryId: string;
  isPrimary: boolean;
}
